import React from "react";
import styles from "./SaleDropdown.module.scss";

interface SaleDropdownProps {
  number: number;
  title: string;
  text: string;
}

const SaleDropdown: React.FC<SaleDropdownProps> = ({ number, title, text }) => {
  const [isActive, setIsActive] = React.useState(false);

  return (
    <div className={isActive ? `${styles.dropdown} ${styles.active}` : styles.dropdown} onClick={() => setIsActive(!isActive)}>
      <div className={styles.title}>
        <div className={styles.info}>
          <div>{number}</div>
          <h3>{title}</h3>
        </div>
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_71_3193)">
            <path
              d="M19.9201 9.72998L13.4001 16.25C12.6301 17.02 11.3701 17.02 10.6001 16.25L4.08008 9.72998"
              stroke="#9D9595"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      </div>
      <div className={styles.content}>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default SaleDropdown;
